import React, { useState } from "react";
import { useMap, useMapsLibrary } from "@vis.gl/react-google-maps";
import { useEffect } from "react";
import { useGetWeatherAlertsMapQuery } from "../store/slices/mapsSlice";
import WeatherAlertsSidebar from "./WeatherAlertsSidebar";
import {
  WeatherAlertConditions,
  WeatherCodes,
} from "../WeatherAlerts/WeatherAlertConstants";
import { WeatherAlertOverlay } from "./MapPopUps";
import { WeatherFiltersType } from "./MapFilters";
import { createRoot } from "react-dom/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCoins } from "@fortawesome/free-solid-svg-icons";
import FilterIcon from "../../assets/icons/Icon_Library/application icons/general/filter.svg2";
import { OverlayTrigger, Popover } from "react-bootstrap";

const WeatherAlertIcon = ({ alert }: { alert: any }) => {
  const [show, setShow] = useState(false);
  const AlertIcon = WeatherAlertConditions.find(
    (wac) => wac.key === alert.Item.Grid[0].Alerts[0].ConditionRaw[0].Condition
  )?.icon;

  return (
    <div onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
      <OverlayTrigger
        show={show}
        placement="auto"
        overlay={
          <Popover className="bg-purple-gradient">
            <Popover.Header as="h3">Weather alert details</Popover.Header>
            <Popover.Body>
              <WeatherAlertOverlay data={alert} type={"cluster"} />
            </Popover.Body>
          </Popover>
        }
      >
        <div
          className="p-1 rounded-circle text-white position-relative"
          title={`${
            alert.IsCluster
              ? alert.ItemCount + " items in this cluster. Click to zoom in."
              : `Click to see alert details for ${alert.Item.Unit.Name}.`
          }`}
          style={{
            width: 30,
            height: 30,
            backgroundColor: alert.Item.Grid[0].Alerts[0].Color,
          }}
        >
          {alert.ItemCount > 1 ? (
            <span
              className="position-absolute badge bg-dark rounded-pill top-0 start-100 translate-middle-x "
              style={{ zIndex: 100 }}
            >
              {alert.ItemCount}
            </span>
          ) : (
            ""
          )}
          {AlertIcon && <AlertIcon className="white icon-bold" />}
        </div>
      </OverlayTrigger>
    </div>
  );
};

export default function WeatherAlerts({
  setOverlay,
  filters,
  setLoading,
}: {
  setOverlay: any;
  filters?: WeatherFiltersType;
  setLoading?: (isLoading: boolean) => void;
}) {
  const map = useMap();
  const marker = useMapsLibrary("marker");
  const [mapBounds, setMapBounds] = useState<{
    west: number;
    north: number;
    east: number;
    south: number;
    centerLng: number;
    centerLat: number;
    zoom?: number;
  }>();
  const [searchArea, setSearchArea] = useState<any[][]>();

  const mapGeometry = useMapsLibrary("geometry");
  const clusteringRadius =
    map && map.getBounds() && mapGeometry
      ? mapGeometry?.spherical.computeDistanceBetween(
          map?.getBounds()?.getNorthEast() as google.maps.LatLng,
          map?.getBounds()?.getSouthWest() as google.maps.LatLng
        ) / 40000
      : 0;

  const {
    data: { clusters, alerts, total } = {
      clusters: [],
      alerts: [],
      total: 0,
    },
    isLoading,
    isFetching,
  } = useGetWeatherAlertsMapQuery(
    {
      ...(mapBounds || {
        west: 0,
        north: 0,
        east: 0,
        south: 0,
        centerLng: 0,
        centerLat: 0,
      }),
      start: filters?.StartAt,
      end: filters?.EndAt,
      conditions: filters?.alertFilters.conditions,
      conditionIds: filters?.alertFilters.conditionIds,
      search: filters?.alertFilters.search,
      radius: clusteringRadius,
    },
    { skip: !mapBounds }
  );

  useEffect(() => {
    if (!setLoading) return;

    if (isFetching || isLoading) {
      setLoading(true);
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }, [isFetching, isLoading, setLoading]);

  // function showAlerts({
  //   alerts,
  //   map,
  //   marker,
  // }: {
  //   alerts: any[] | undefined;
  //   map: google.maps.Map;
  //   marker: google.maps.MarkerLibrary | null;
  // }) {
  //   if (!map || !marker) return;
  //   const locationShapes: any[] = [];

  //   alerts?.forEach((alert: any) => {
  //     if (!alert.Grid[0].Alerts[0].AlertCondition) {
  //       return;
  //     }
  //     const markerElement = document.createElement("div");
  //     const root = createRoot(markerElement);
  //     const weatherAlertCondition = WeatherAlertConditions.find(
  //       (wac) =>
  //         wac.key ===
  //         alert.Grid[0].Alerts[0].AlertCondition.ConditionDetails[0].Condition
  //     );

  //     let AlertIcon = weatherAlertCondition?.icon;

  //     if (
  //       weatherAlertCondition &&
  //       (weatherAlertCondition.key === "daySignificantWeatherCode" ||
  //         weatherAlertCondition.key === "nightSignificantWeatherCode")
  //     ) {
  //       const weatherCode = WeatherCodes.find(
  //         (wc) =>
  //           wc.value ===
  //           alert.Grid[0].Alerts[0].AlertCondition.ConditionDetails[0]
  //             .ConditionValue[0]
  //       );
  //       AlertIcon = weatherCode?.icon;
  //     }

  //     root.render(
  //       <div
  //         className="p-1 rounded-circle text-white position-relative"
  //         style={{
  //           width: 30,
  //           height: 30,
  //           backgroundColor: alert.Grid[0].Alerts[0].Color,
  //         }}
  //       >
  //         {AlertIcon && <AlertIcon className="white icon-bold" />}
  //       </div>
  //     );
  //     const m = new marker.AdvancedMarkerElement({
  //       position: {
  //         lat: alert.Unit.Point?.coordinates[1] ?? 0,
  //         lng: alert.Unit.Point?.coordinates[0] ?? 0,
  //       },
  //       content: markerElement,
  //       map,
  //     });
  //     m.addListener("click", (e: any) => {
  //       setOverlay({
  //         show: true,
  //         content: <WeatherAlertOverlay data={alert} type={"alert"} />,
  //         position: { x: e.domEvent.x, y: e.domEvent.y },
  //       });
  //     });
  //     // (m as any).clusterData = cluster;
  //     locationShapes.push(m);
  //   });
  //   return locationShapes;
  // }

  // useEffect(() => {
  //   if (!map || !alerts) return;

  //   const shapes: any[] =
  //     showAlerts({
  //       alerts,
  //       map,
  //       marker,
  //     }) || [];

  //   return () => {
  //     shapes.forEach((shape) => {
  //       shape.setMap?.(null);
  //       shape.map = null;
  //     });
  //   };
  // }, [map, alerts, filters]);

  function showClusters({
    clusters,
    map,
    marker,
  }: {
    clusters: any[] | undefined;
    map: google.maps.Map;
    marker: google.maps.MarkerLibrary | null;
  }) {
    if (!map || !marker) return;
    const locationShapes: any[] = [];

    clusters?.forEach((alert: any) => {
      const markerElement = document.createElement("div");
      const root = createRoot(markerElement);
      root.render(<WeatherAlertIcon alert={alert} />);
      const m = new marker.AdvancedMarkerElement({
        position: {
          lat: alert.Item.Unit.Point?.coordinates[1] ?? 0,
          lng: alert.Item.Unit.Point?.coordinates[0] ?? 0,
        },
        content: markerElement,
        map,
      });
      if (alert.IsCluster) {
        m.addListener("click", (e: any) => {
          let bounds = new google.maps.LatLngBounds();
          var east = google.maps.geometry.spherical.computeOffset(
            {
              lat: alert.Item.Unit.Point?.coordinates[1] ?? 0,
              lng: alert.Item.Unit.Point?.coordinates[0] ?? 0,
            },
            clusteringRadius * 1000,
            90
          );
          bounds.extend(east);
          var west = google.maps.geometry.spherical.computeOffset(
            {
              lat: alert.Item.Unit.Point?.coordinates[1] ?? 0,
              lng: alert.Item.Unit.Point?.coordinates[0] ?? 0,
            },
            clusteringRadius * 1000,
            270
          );
          bounds.extend(west);

          map.fitBounds(bounds);
        });
      }
      // if (!alert.IsCluster) {
      //   m.addListener("click", (e: any) => {
      //     setOverlay({
      //       show: true,
      //       content: <WeatherAlertOverlay data={alert} type={"cluster"} />,
      //       position: { x: e.domEvent.x, y: e.domEvent.y },
      //     });
      //   });
      // }
      // (m as any).clusterData = cluster;
      locationShapes.push(m);
    });
    return locationShapes;
  }

  useEffect(() => {
    if (!map || !clusters) return;

    const shapes: any[] =
      showClusters({
        clusters,
        map,
        marker,
      }) || [];

    return () => {
      shapes.forEach((shape) => {
        shape.setMap?.(null);
        shape.map = null;
      });
    };
  }, [map, clusters, filters]);

  useEffect(() => {
    if (!map) return;

    const boundChageEvent = map.addListener("idle", () => {
      if (!map || !map.getBounds() || !map.getCenter()) return;
      const zoom = map.getZoom();

      setMapBounds({
        centerLng: map.getCenter()?.toJSON().lng || 0,
        centerLat: map.getCenter()?.toJSON().lat || 0,
        ...(map.getBounds()?.toJSON() || {
          west: 0,
          north: 0,
          east: 0,
          south: 0,
        }),
        // zoom: !!zoom && zoom < 7 ? zoom - 1 : undefined,
      });
    });

    return () => {
      google.maps.event.removeListener(boundChageEvent);
    };
  }, [map]);

  return (
    <>
      <div className="d-flex justify-content-start fw-bold mt-2 p-2">
        Total of {total} weather alerts found.
        <WeatherAlertsSidebar
          bounds={searchArea || mapBounds}
          filters={filters}
        />
      </div>
    </>
  );
}
